import { createApp } from 'vue'
import App from './components/HelloWorld.vue'
// Importa o CSS comum
import './assets/css/common.css';

//Importa o tema minimal
import './assets/css/themes/theme-minimal.css';

import 'intl-tel-input/build/css/intlTelInput.css'


createApp(App).mount('#app')
